import React from 'react'
// components
import { IconButton } from 'components/UI'
// icons
import TableViewIcon from '@mui/icons-material/TableView'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'

const ToggleTableTreeButton: React.FC = () => {
  const { isTableTree, toggleTableTree } = React.useContext(PlanEditPageContext)

  return (
    <IconButton onClick={toggleTableTree} isActive={isTableTree} description='Change View Mode'>
      <TableViewIcon />
    </IconButton>
  )
}

export default ToggleTableTreeButton
